import classNames from 'classnames';
import { Col, Row } from 'react-bootstrap';

interface FooterProps {
  className?: string;
}

const Footer = ({ className }: FooterProps) => {
  return (
    <footer className={classNames(className, 'footer')}>
      <Row className="g-1 justify-content-between align-items-center h-100">
        <Col xs={12} sm="auto" className="text-center">
          <p className="mb-0 mt-2 mt-sm-0 text-body fs-9">
            Humanized Virtual Agents Management System
            <span className="d-none d-sm-inline-block" />
            <span className="d-none d-sm-inline-block mx-1">|</span>
            <br className="d-sm-none" />
            {new Date().getFullYear()} &copy;{' '}
            <a
              href={`${import.meta.env.VITE_COMPANYURL}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {import.meta.env.VITE_COMPANY}
            </a>
          </p>
        </Col>
        <Col xs={12} sm="auto" className="text-center">
          <p className="mb-0 text-body-tertiary text-opacity-85 fs-9">
            v{import.meta.env.VITE_VERSION}
          </p>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;
